import { render, staticRenderFns } from "./NewProviderModal.vue?vue&type=template&id=0054935a&"
import script from "./NewProviderModal.vue?vue&type=script&lang=js&"
export * from "./NewProviderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProviderModal.vue"
export default component.exports